import { render } from "./ViewForm.vue?vue&type=template&id=39b5b090&ts=true"
import script from "./ViewForm.vue?vue&type=script&lang=ts"
export * from "./ViewForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__